import Vue from 'vue'
import Vuex from 'vuex'

import config from '../config';

Vue.use(Vuex);


const store = {
	state: {
		bases: {
			fileApi: "https://assetlocker-api.asset-locker.dev-a.hpgsb.net/api",
			rasterApi: config.rasterApi
		},
		items: [],
		item: {},
		path: "/"
	},
	getters: {
		bases: state => state.bases,
		path: state => state.path,
		items: state => state.items,
		item: state => state.item,
		folders: state => state.items.filter(item => item.type === 'folder'),
		files: state => state.items.filter(item => item.type === 'file')
	},
	mutations: {
		'SET_PATH': (state, path) => state.path = path,
		'SET_ITEMS': (state, docs) => state.items = docs,
		'SET_ITEM': (state, doc) => state.item = doc
	},
	actions: {
		setPath: ({ commit, state, dispatch }, path) => {
			commit('SET_PATH', path);
			dispatch("loadItems", path);
		},
		createPath: async ({ commit, state }, path) => {
			const url = `${state.bases.fileApi}/paths`;
			const results = await Vue.http.post(url, path);
			return results;
		},
		loadItems: ({ commit, state }, path) => {
			const url = `${state.bases.fileApi}${path}`;
			Vue.http.get(url).then((results) => {
				commit('SET_ITEMS', results.body.content);
				commit('SET_ITEM', results.body.data);
			});
		}
	}
};

export default new Vuex.Store(store);



// WEBPACK FOOTER //
// ./src/vuex/store.js